import { FBase } from "../firebase/firebase.base";
import { isNullOrUndefined, isObject } from "@pineapplelab/util";
import { Paging } from "../paging";
import { Custom, IsNotEmpty } from "@pineapplelab/validators";
import { Category } from "../firebase/category";
import { currencyTypeEnum } from "@app/enums/currencyType.enum";
import { TimestampDateMatch } from "@app/decorator/timestamp-date-match.decorator";
import { ILatLng } from "@app/interfaces/lat-lng.interface";
import { EnumWorkModality } from "@app/enums/work-modality.enum";
import { EnumTimeModality } from "@app/enums/time-modality.enum";
import { PagingOrderType } from "@pineapplelab/paging";

export interface IJobOfferAiEvaluation {
  enabled: boolean;
  requiredQualifications: string;
  desiredQualifications: string;
  technicalSkills: string;
  experienceRequirements: string;
  additionalContext: string;
  /** Language for AI output — 'es' (default) or 'en'. */
  evaluationLanguage: 'es' | 'en';
}


export class JobOffer extends FBase {
  @IsNotEmpty() company: string = null;
  @IsNotEmpty() title: string = null;
  @IsNotEmpty() position: string = null;
  description: string = null;
  category: Category.ICategory = null;
  @TimestampDateMatch()
  dateFrom: Date = null;
  @TimestampDateMatch()
  @Custom((object, field) => isNullOrUndefined(object[field]) || isNullOrUndefined(object.dateFrom) || new Date(object[field]).getTime() >= new Date(object.dateFrom).getTime(), { message: 'End date must be after or equal to start date' })
  dateUntil: Date = null;
  address: string = null;
  location: ILatLng = null;
  zipCode: string = null;
  postulationsQuantity: number = 0;
  @IsNotEmpty() workModalities: EnumWorkModality[];
  @IsNotEmpty() timeModality: EnumTimeModality;
  currency: currencyTypeEnum = null;
  salaryFrom: number = null;
  @Custom((object, field) => isNullOrUndefined(object[field]) || isNullOrUndefined(object.salaryFrom) || object[field] >= object.salaryFrom, { message: '"To" must be greater than or equal to "From"' })
  salaryTo: number = null;
  gender: string = null;
  vacancies: number = null;
  education: string = null;
  offerUrl: string = null;

  jobOfferWorkflowTemplateId: string = null;
  aiEvaluation: IJobOfferAiEvaluation = {
    enabled: false,
    requiredQualifications: '',
    desiredQualifications: '',
    technicalSkills: '',
    experienceRequirements: '',
    additionalContext: '',
    evaluationLanguage: 'es',
  };

  constructor(json?: { [key: string]: any }) {
    super();

    if (isObject(json)) {
      this.fromJson(json);
    }
  }
}

export namespace JobOffer {

  export const PATH = 'jobOffers';
  export const PAGING = new Paging<JobOffer>(<Paging.IPaging>{
      collection: PATH,
      orderOptions: [
        { field: 'title', label: 'Title', placeholder: 'Filter by title', dataType: Paging.dataType.string },
        { field: 'created_at', label: 'Created at', dataType: Paging.dataType.timestamp },
      ],
      orderType: PagingOrderType.desc,
      orderBy: 'created_at',
  });
}
